import Vue from 'vue';
import { ValidationProvider, ValidationObserver, localize, configure } from 'vee-validate';
import hu from 'vee-validate/dist/locale/hu.json';
import './extend';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

localize('hu', hu);

configure({
	classes: {
		valid: 'accept-field',
		invalid: 'error-field',
	},
});
